import { render } from "./CheckoutShippingMethods.vue?vue&type=template&id=270eed5a&scoped=true"
import script from "../js/checkoutShippingMethods.js?vue&type=script&lang=js&external"
export * from "../js/checkoutShippingMethods.js?vue&type=script&lang=js&external"

import "./CheckoutShippingMethods.vue?vue&type=style&index=0&id=270eed5a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-270eed5a"]])

export default __exports__